module.exports = __webpack_public_path__ + "img/material-symbols_check-circle-outline.7fefdf23.svg";